import React from "react";
import { ArrowRight } from "lucide-react";

const COMPRESSOR_IMG =
  "https://images.unsplash.com/photo-1738918922725-d70c666ddccb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwzfHxpbmR1c3RyaWFsJTIwYWlyJTIwY29tcHJlc3NvciUyMGZhY3RvcnklMjBtYWNoaW5lcnl8ZW58MHx8fHwxNzc4MTI1MTQxfDA&ixlib=rb-4.1.0&q=85";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export const ShowcaseStrip = () => {
  return (
    <section
      data-testid="showcase-strip"
      className="relative h-[420px] md:h-[520px] overflow-hidden bg-slate-900"
    >
      <div
        className="absolute inset-0 bg-cover bg-center scale-105"
        style={{
          backgroundImage: `url(${COMPRESSOR_IMG})`,
          backgroundAttachment: "fixed",
        }}
        aria-hidden
      />
      <div className="absolute inset-0 bg-gradient-to-r from-slate-950/95 via-slate-900/70 to-slate-900/40" aria-hidden />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_50%,rgba(37,99,235,0.18),transparent_55%)]" aria-hidden />

      <div className="relative h-full max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
        <div className="lg:col-span-7 stagger-item">
          <div className="text-[11px] font-bold tracking-[0.2em] uppercase text-blue-400">
            Built around uptime
          </div>
          <h2 className="font-heading mt-3 text-4xl md:text-6xl font-black tracking-tighter uppercase text-white leading-[0.95]">
            Industrial-grade equipment.
            <span className="block text-blue-400">Expert hands.</span>
          </h2>
          <p className="mt-5 max-w-xl text-base md:text-lg text-slate-300">
            Rotary screw, reciprocating, centrifugal — Pneupro services every type of compressor
            you run on the floor. Genuine OEM parts. Trade-qualified millwrights. Across British
            Columbia.
          </p>
          <button
            onClick={() => scrollTo("services")}
            data-testid="showcase-services-button"
            className="mt-8 bg-white text-slate-900 hover:bg-blue-600 hover:text-white font-bold tracking-wide uppercase px-7 py-3.5 inline-flex items-center gap-2 transition-all hover:-translate-y-0.5"
          >
            Explore services <ArrowRight className="h-4 w-4" />
          </button>
        </div>

        <div className="hidden lg:flex lg:col-span-5 justify-end gap-3">
          <Stat value="ALL" label="Compressor types" />
          <Stat value="OEM" label="Genuine parts" />
          <Stat value="BC" label="Service region" />
        </div>
      </div>
    </section>
  );
};

const Stat = ({ value, label }) => (
  <div className="bg-white/5 border border-white/10 backdrop-blur-md p-5 w-32 text-white">
    <div className="font-heading text-3xl font-black">{value}</div>
    <div className="text-[10px] font-bold tracking-widest uppercase text-slate-300 mt-2">
      {label}
    </div>
  </div>
);

export default ShowcaseStrip;
